import * as Diagram from "../../../../components/diagram";

export const BasicDataStatisticalAnalysis = {
  label: "基本資料統計分析",
  key: "BasicDataStatisticalAnalysis",
  path: "ServiceApplication/BasicDataStatisticalAnalysis",
  api: "TCS_V_ServiceApplication_1",
  render: (options) => (
    <Diagram.ServiceApplication.BasicDataStatisticalAnalysis {...options} />
  ),
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  columns: [
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "連絡電話",
      field: "連絡電話",
      header: "連絡電話",
    },
    {
      key: "行動電話",
      field: "行動電話",
      header: "行動電話",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "轉介來源",
      field: "轉介來源",
      header: "轉介來源",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "問題類型",
      field: "問題類型",
      header: "問題類型",
    },
    {
      key: "處理狀況",
      field: "處理狀況",
      header: "處理狀況",
    },
    {
      key: "申請結果",
      field: "申請結果",
      header: "申請結果",
    },
    {
      key: "服務項目",
      field: "服務項目",
      header: "服務項目",
    },
  ],
};
